import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import Cookies from 'js-cookie';
import { map, ReplaySubject, Subject, tap } from 'rxjs';
import { AuthConfigToken } from '../../ng-security.module';
import { PlatformService } from '../../service';

@Service({ autoProvided: false })
export class WebappService {
  readonly #http = inject(HttpClient);

  readonly #platform = inject(PlatformService);

  readonly #authConfig = inject(AuthConfigToken);

  readonly #useUserCookie = this.#authConfig.useUserCookie === true;

  private static loginSubject?: Subject<unknown>;

  public login(forceNoCache = false) {
    if (WebappService.loginSubject) {
      return WebappService.loginSubject.asObservable();
    }

    WebappService.loginSubject = new ReplaySubject();
    const obs = WebappService.loginSubject.asObservable();

    this.#performLogin(forceNoCache)
      .pipe(
        tap(() => {
          WebappService.loginSubject = undefined;
        }),
      )
      .subscribe(WebappService.loginSubject);

    return obs;
  }

  #performLogin(forceNoCache = false) {
    const formData = new FormData();
    let route = '/secure/platform-token';

    // Ugly workaround for BC
    if (this.#useUserCookie) {
      const userCookie = Cookies.get('user_id');

      if (userCookie) {
        formData.append('user', userCookie ?? '');
        route = '/platform_token';
      }
    }

    formData.append('forceNoCache', forceNoCache ? 'true' : 'false');

    // This runs only in the webapp context, so we can use a relative path here to avoid env vars
    return this.#http.post(route, formData).pipe(
      map((response) => {
        const { token } = response as { token: string };
        this.#platform.handleToken(token);
        return token;
      }),
    );
  }
}
